import React from 'react';

import { withAuthLayout } from '@/layouts/Auth';

import { useSelector } from 'react-redux';

export const MfaErrorPage = () => {
  const mfaStatus = useSelector((state) => state.mfa?.status || 'Unknown');
  const error = useSelector(
    (state) => state.mfa?.error || { code: 'N/A', message: 'No error message available' }
  );

  if (error.code === 'NO_USABLE_DEVICES') {
    return (
      <div className="text-center py-5">
        <h1 className="text-2xl font-bold mb-4">MFA Error</h1>
        <p className="text-red-500 mb-4">Status: {mfaStatus}</p>
        <p className="text-red-500">Error: {error.code}</p>
        <p className="text-red-500">Reason: {error.message}</p>
      </div>
    );
  }

  return (
    <div className="text-center py-5">
      <h1 className="text-2xl font-bold mb-4">MFA Error</h1>
      <p className="text-red-500 mb-4">Status: {mfaStatus}</p>
      <p className="text-red-500">Error: {error.code}</p>
      <p className="text-red-500">Reason: {error.message}</p>
    </div>
  );
};

export default withAuthLayout(MfaErrorPage, {
  enableProfiler: true,
  enableErrorBoundary: true
});
